export const sourcesNamesMap: any = {
  echo_global: 'Echo global',
  coyote: 'Coyote',
  uber: 'Uber',
  newtrul: 'Newtrul',
  ch_robinson: 'CH Robinson',
  loadsmart: 'Loadsmart',
  dat: 'DAT'
};
